import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, of, throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class KbService {

  features: Array<any> = [];
  public featureListReLoad = new BehaviorSubject(null);
  public updateKBContent: EventEmitter<Object> = new EventEmitter();

  constructor(private http: HttpClient) { }
  uploadKb(agentId, file) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(environment.kb_service_api + 'ontology/upload_kb/' + agentId, formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    }).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        console.error('An error occurred:', error);
        return error;
      })
    );
  }

  createKB(agentId, formdata) {
    return this.http.post(environment.kb_service_api + 'ontology/create_kb/' + agentId, formdata)
  }

  deleteKB(agentId) {
    return this.http.delete(environment.kb_service_api + 'ontology/delete_kb/' + agentId)
  }

  getTreeData(agentId, nodeType) {
    return this.http.get(environment.ontology_service_api + agentId + '/get_tree_data')
  }

  updateNode(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/update_node', params)
  }

  addNode(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/add_node/', params)
  }

  removeNode(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/delete_node', params)
  }

  checkNode(agentId, nodeId) {
    return this.http.get(environment.ontology_service_api + agentId + '/' + nodeId + '/ischild')
  }

  getNodeFeatures(agentId, data, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/get_mapped_data_properties?limit=' + params.limit + '&offset=' + params.offset + '&query=' + params.query, data)
  }

  updateNodeFeature(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/mapped_property_upsert', params)
  }

  deleteNodeFeature(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/mapped_property_delete', params)
  }

  getFeatures(agentId) {
    return this.http.get(environment.ontology_service_api + agentId + '/get_data_properties/')
      .pipe(
        map((response: Array<Object>) => {
          this.features = response;
          return response;
        })
      );
  }

  getLimitedFeatures(agentId, limit, offset, sortKey=undefined, sortOrder=undefined) {
    let url = environment.ontology_service_api + agentId + '/get_data_properties?limit=' + limit + '&offset=' + offset;
    if(sortKey){
      url += '&sort_key=' + sortKey + '&sort_order=' + sortOrder;
    } else {
      url += '&sort_order=' + sortOrder;
    }
    return this.http.get(url).pipe(
      map((response: Array<Object>) => {
        this.features = response;
        return response;
      })
    );
  }

  getSearchFeatures(agentId, query, limit, offset, sortKey=undefined, sortOrder=undefined, strict=false) {
    let url = environment.ontology_service_api + agentId + '/feature/search?query=' + query + '&limit=' + limit + '&offset=' + offset + '&strict=' + strict;
    if(sortKey){
      url += '&sort_key=' + sortKey + '&sort_order=' + sortOrder;
    } else {
      url += '&sort_order=' + sortOrder;
    }
    return this.http.get(url).pipe(
      map((response: Array<Object>) => {
        this.features = response;
        return response;
      })
    );
  }

  getFeaturesTypeahead(agentId, query, limit, offset, include_default=false) {
    return this.http.get(environment.ontology_service_api + agentId + '/feature/search?query=' + query + '&limit=' + limit + '&offset=' + offset + "&include_default=" + include_default)
      .pipe(
        map((response: Array<Object>) => {
          return response['result'];
        })
      );
  }

  getSubFeatureTypeahead(agentId, query, limit, offset, feature_uri) {
    console.log("getSubFeatureTypeahead")
    return this.http.get(environment.ontology_service_api + agentId + '/sub_feature_search?query=' + query + '&limit=' + limit + '&offset=' + offset+'&feature_uri='+feature_uri)
      .pipe(
        map((response: Array<Object>) => {
          return response['result'];
        })
      );
  }

  getSearchUtterances(agentId, query, limit, offset, sortKey=undefined, sortOrder=undefined, strict=false) {
    let url = environment.ontology_service_api + agentId + '/utterances/search?query=' + query + '&limit=' + limit + '&offset=' + offset
     + '&strict=' + strict;
    if(sortKey){
      url += '&sort_key=' + sortKey + '&sort_order=' + sortOrder;
    } else {
      url += '&sort_order=' + sortOrder;
    }
    return this.http.get(url)
      .pipe(
        map((response: any) => {
          this.features = response;
          return response;
        })
      );
  }

  getFeatureList(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/get_dropdown_data_properties', params)
      .pipe(
        map((response: Array<Object>) => {
          this.features = response;
          return response;
        })
      );
  }

  getFeaturebySearch(agentId, item, term) {
    const params = {
      'uri': item
    };
    return this.http.post(environment.ontology_service_api + agentId + '/get_dropdown_data_properties?query=' + term, params)
      .pipe(
        map((response: Array<Object>) => {
          this.features = response;
          return response;
        })
      );
  }

  getPropertyValue(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/get_mapped_data_properties_value', params)
  }

  getFeatureDomains(agentId) {
    return this.http.get(environment.ontology_service_api + agentId + '/get_concepts')
      .pipe(
        map((response: Array<Object>) => {
          return response;
        })
      );
  }

  createFeature(params, agentId) {
    return this.http.post(environment.ontology_service_api + agentId + '/add_node/', params)
  }
  //<topic_uri>/<feature_uri>/<attached_topic>/feature_topic_data
  getDataForTopic(agentId,topic_uri,feature_uri,attached_topic_uri) {
    
    return this.http.get(environment.multi_topic_api +agentId+'/' + topic_uri+'/'+feature_uri+'/'+attached_topic_uri+ '/feature_topic_data')
  }

  // getDataForTopic(params, agentId) {
  //   return this.http.post(environment.multi_topic_api + agentId + '/add_node/', params)
  //     .map((response) => {
  //       return response;
  //     },
  //       (err: Response) => {
  //         return err;
  //       });
  // }

  changeFeatureDomain(params, agentId) {
    return this.http.post(environment.ontology_service_api + agentId + '/change_domain/', params)
  }

  updateFeature(params, agentId) {
    return this.http.post(environment.ontology_service_api + agentId + '/update_node/', params)
  }

  deleteFeature(params, agentId) {
    return this.http.post(environment.ontology_service_api + agentId + '/delete_node/', params)
  }

  saveRecommendationFordisplay(params, agentId){
    return this.http.post(environment.kb_service_api + 'ontology_interface/' + agentId + '/edit_recommendation_fordisplay', params)
  }

  deleteRecommendationFordisplay(params, agentId){
    return this.http.post(environment.kb_service_api + 'ontology_interface/' + agentId + '/delete_recommendation_fordisplay', params)
  }

  moveNode(params, agentId) {
    return this.http.post(environment.ontology_service_api + agentId + '/move_topic', params)
  }

  getRivescript(agentId) {
    return this.http.get(environment.kb_service_api + 'editor/' + agentId + '/rivescript')
  }

  updateRivescript(agentId, params) {
    return this.http.post(environment.kb_service_api + 'editor/' + agentId + '/rivescript', params)
  }

  getMappedTopics(agentId, uri) {
    return this.http.get(environment.ontology_service_api + agentId + `/feature/${uri}/get_mapped_topics`)
      .pipe(
        map((response: Array<Object>) => {
          return response;
        })
      );
  }
  //To get feture/subfeature content template count
  getMappedTopicsContentTemplateCount(agentId, param){
    return this.http.post(environment.ontology_service_api +  agentId +'/get_feature_content_template', param)
  }

  getMappedSubFeatures(agentId, uri) {
    return this.http.get(environment.ontology_service_api + agentId + `/${uri}/get_sub_feature_feature_mapped_topics`)
  }
  getSubFeatureInfo(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/get_sub_features', params)
  }
  getSubDataproperties(agentId, topic_uri, feature_uri) {
    return this.http.get(environment.ontology_service_api + agentId + `/topic/${feature_uri}/feature/${topic_uri}/get_sub_dataproperties`)
      .pipe(
        map((response:  Array<Object>) => {
          return response;
        })
      );
  }

  getSuggestedSubProperties(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/get_suggested_features', params)
  }

  saveSubDatapropertiesOrder(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/subfeature_order', params)
  }

  saveSubDataPropertyRename(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/subfeature_rename/', params)
  }

  // for Retriving feature forDispaly from URI 
  getForDisplay(agentId, data) {
    return this.http.post(environment.kb_service_api + 'ontology_interface/' + agentId + '/get_feature_fordisplay', data)
  }

  searchTopic(agentId, term) {
    return this.http.get(environment.ontology_service_api + agentId + '/topic_search?query=' + term).pipe(
      map((response: Array<Object>) => {
        return response['result'];
      })
    );
  }

  addTree(agentId, article_id, parent_topic) {
    return this.http.get(environment.ontology_service_api + agentId + '/' + article_id + '/' + parent_topic + '/create-tree').pipe(
      map((response:  Array<Object>) => {
        return response['result'];
      })
    );
  }
  copyContent(agentId, data){
    return this.http.post(environment.kb_service_api + 'ontology_interface/' + agentId + "/move_content", data)

  }
  getFeatureValue(agentId, data){
    return this.http.post(environment.kb_service_api + 'ontology_interface/' + agentId + "/mapped_profile_value", data)
  }

  listSubFeature(agentId, limit, offset, sortOrder,sortKey) {
    return this.http.get(environment.ontology_service_api + agentId + "/list_all_sub_features?limit=" + limit + "&offset=" + offset + "&order=" + sortOrder+"&sort_by="+sortKey)
  }

  getSubFeatureMappedFeature(agentId, forDisplay) {
    return this.http.post(environment.ontology_service_api + agentId  + "/get_sub_feature_mapped_feature", {"fordisplay": forDisplay})
  }

  searchSubFeature(agentId, query, limit, offset) {
    return this.http.get(environment.ontology_service_api + agentId + "/sub_feature_search?query=" + query + "&limit=" + limit + "&offset=" + offset)
  }

  getFeatureSubFeatureMappedTopic(agentId, subFeatureForDisplay, featureURI) {
    const data = {
      fordisplay: subFeatureForDisplay
    };
    return this.http.post(environment.ontology_service_api + agentId + "/" + featureURI  + "/get_sub_feature_feature_mapped_topics", data)
  }

  deleteSubFeature(agentId, forDisplay) {
    let data = {
      forDisplay: forDisplay
    }
    return this.http.post(environment.ontology_service_api + agentId + "/delete_subfeatures", data);
  }

  checkFlowTriggerFeature(agentId, uri) {
    return this.http.get(environment.ontology_service_api + agentId + "/" + uri + "/check_feature_flow_trigger_library")
  }

  checkFlowTriggerSubFeature(agentId, forDisplay) {
    return this.http.post(environment.ontology_service_api + agentId  + "/check_subfeature_flow_trigger_library", {"subfeature": forDisplay})
  }

  checkFlowTriggerFeatureKb(agentId, uri, topic_uri) {
    return this.http.get(environment.ontology_service_api + agentId + "/" + uri + "/" + topic_uri + "/check_feature_flow_trigger_kb")
  }

  checkFlowTriggerSubFeatureKb(agentId, uri, topic_uri, feature_uri) {
    return this.http.get(environment.ontology_service_api + agentId + "/" + uri + "/" + topic_uri + "/" + feature_uri + "/check_subfeature_flow_trigger_kb")
  }
  
  checkProfileFlowTriggerKb(agentId, topicURI, featureURI, profileId) {
    return this.http.get(environment.profile_service_api + agentId + "/" + topicURI + "/" + featureURI + "/" + profileId + "/check_status_profile_trigger")
  }

  getImmediateSubTopics(agentId, topicURI) {
    return this.http.get(environment.kb_service_api + 'ontology_interface/' + agentId + '/' + topicURI + '/get_immediate_subtopics')
  }

  isMappedFeature(agentId, topicURI, featureURI) {
    return this.http.get(environment.ontology_service_api + agentId + '/' + topicURI + '/' + featureURI + '/isDuplicate')
  }
  downloadLibrary(agentId,type){
    return this.http.get(environment.ontology_service_api + agentId  + '/' + type + '/download_library')

  }



  subFeatureSearch(agentId, url,  query, sortOrder, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/search_mapped_sub_properties' + url + '&query=' + query
     + '&sort_order=' + sortOrder, params )
  }

  updateKBFile(agentId) {
    return this.http.get(environment.kb_service_api + 'ontology/template/' + agentId + '/is_created' )
  }

  addSecondaryForDisplay(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/secondary-for-display', params)
  }

  listSecondaryForDisplay(agentId, topicUri) {
    return this.http.get(environment.ontology_service_api + agentId + '/secondary-for-display/' + topicUri)
  }

  deleteSecondaryForDisplay(agentId, topicUri, featureUri) {
    return this.http.delete(environment.ontology_service_api + agentId + '/secondary-for-display/' + topicUri + '/'
     + featureUri)
  }

  getConflictLists(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/fetch_conflicts', params)
  }

  getRecommendationDocuments(agentId, params) {
    return this.http.post(environment.ontology_service_api + agentId + '/get_recommendation_docs', params)
  }

  // download kb excel 
  downloadfullKBData(agentId) {
    return this.http.get(environment.ontology_service_api + agentId + '/download_kb')
  }

  saveExtractedInfo(agentId, params){
    return this.http.post(environment.ontology_service_api + agentId + '/save_extracted_info', params)
  }

  getExtractedInfo(agentId){
    return this.http.get(environment.ontology_service_api + agentId + '/get_extracted_info')
  }

  deleteExtractedInfo(agentId, record_id) {
    return this.http.post(environment.ontology_service_api + agentId + '/' + record_id + '/delete_extracted_info', {})
  }

  saveGeneratedQuestions(agentId, params){
    return this.http.post(environment.ontology_service_api + agentId + '/save_generated_question', params)
  }

  getGeneratedQuestions(agentId, fileid, limit=10, offset=0) {
    const params = new HttpParams()
        .set('limit', limit.toString())
        .set('offset', offset.toString());

  return this.http.get(environment.ontology_service_api + agentId + '/' + fileid + '/get_generated_questions', { params });
}

  uploadDocments(agentId, files) {
    const formData: FormData = new FormData();
    formData.append('files[]', files.file, files.filename);
    formData.append('profile', files.profile ? files.profile : '');
    formData.append('document_process', files.document_process ? files.document_process : 'regular_document')
    formData.append('fileTags', files.file_tags ? JSON.stringify(files.file_tags) : '[]');

    return this.http.post(environment.kb_service_api + "document_library/" + agentId + "/upload_documents", formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    }).pipe(
      catchError((error) => {
        console.error('Error uploading documents:', error);
        return throwError(error); 
      })
    );
  }

  getDocuments(agentId, params) {
    return this.http.post(environment.kb_service_api + "document_library/" + agentId + "/get_documents", params)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          console.log(err);
          return of(null);
        })
      );
  }

  deleteDocuments(agentId, docIdList) {
    let params = { documentIdList: docIdList };
    return this.http.post(environment.kb_service_api + "document_library/" + agentId + "/doc_delete_documents", params).pipe(
      catchError((error) => {
        console.log(error);
        return throwError(error);
      })
    );
  }

  switchDocumentType(agentId, documentId, params) {
    return this.http.post(environment.kb_service_api + "document_library/" + agentId + "/change_file_access/" + documentId, params)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(error);
        })
      );
  }

  deleteDocument(agentId, documentId) {
    return this.http.delete(environment.kb_service_api + "document_library/" + agentId + "/delete_document/" + documentId, {}).pipe(
      catchError((error) => {
        console.error('Error deleting document:', error);
        return throwError(error);
      })
    );
  }

  getDocumentFile(agentId, documentId, type) {
    return this.http.get(environment.kb_service_api + "document_library/" + agentId + "/fetch_document/" + documentId, { responseType: 'blob' })
  }

  checkFlowMapping(agentId, documentId) {
    return this.http.get(environment.kb_service_api + "document_library/" + agentId +  "/check_document_mapping_flow/" + documentId, {}).pipe(
      catchError((error) => {
        console.error('Error checking flow mapping:', error);
        return throwError(error);
      })
    );
  }

  editFIle(agentId, documentId, params) {
    return this.http.put(environment.kb_service_api + "document_library/" + agentId +  "/edit/" + documentId, params).pipe(
      catchError((error) => {
        console.error( error);
        return throwError(error);
      })
    );
  }

  searchTags(agentId: string, query: string): Observable<string[]> {
    return this.http.get(environment.kb_service_api + "document_library/" + agentId + "/search_tags?query=" + query)
        .pipe(
            map(response => (response as { tags: string[] }).tags),
            catchError((error) => {
                console.error("Error fetching tags:", error);
                return throwError(error);
            })
        );
}


}
